import { render } from "./TextComponentViewer.vue?vue&type=template&id=661812ce&scoped=true&ts=true"
import script from "./TextComponentViewer.vue?vue&type=script&lang=ts"
export * from "./TextComponentViewer.vue?vue&type=script&lang=ts"

import "./TextComponentViewer.vue?vue&type=style&index=0&id=661812ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-661812ce"]])

export default __exports__